<template>
  <div class="help">
    <h3>网页版更符合工作量较大，日常使用电脑制作配音的场景，开始学起来吧！</h3>
    <h3>先输入文本，再选择喜欢的主播和背景音乐，然后编辑文本发音和播放效果，仔细试听无误后，再保存下载音频文件即可</h3>
    <video controls class="video">
      <source src="http://manageweb.oss-cn-beijing.aliyuncs.com/soundx_web_res/svoice_web_app_tutorial.mp4" type="video/mp4">
    </video>
    <h2>第一步：登录注册</h2>
    <img src="@/assets/images/help/0.jpg" alt=""/>
    <img src="@/assets/images/help/1.jpg" alt=""/>
    <h2>第二步：粘贴文本</h2>
    <img src="@/assets/images/help/2.jpg" alt="">
    <h2>第三步：选背景音乐和主播</h2>
    <img src="@/assets/images/help/3.jpg" alt="">
    <img src="@/assets/images/help/4.jpg" alt="">
    <img src="@/assets/images/help/5.jpg" alt="">
    <img src="@/assets/images/help/6.jpg" alt="">
    <h2>第四步：调整播放参数和修正文本</h2>
    <img src="@/assets/images/help/7.jpg" alt="">
    <img src="@/assets/images/help/8.jpg" alt="">
    <img src="@/assets/images/help/9.jpg" alt="">
    <img src="@/assets/images/help/10.jpg" alt="">
    <h2>第五步：导出下载作品</h2>
    <img src="@/assets/images/help/11.jpg" alt="">
    <img src="@/assets/images/help/12.jpg" alt="">
    <img src="@/assets/images/help/13.jpg" alt="">
    <img src="@/assets/images/help/14.jpg" alt="">
  </div>
</template>

<script>
export default {
  name: 'help',
  props: {
    msg: String
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.help {
  padding: 100px 0 0;
  max-width: 1080px;
  margin: 0 auto;
  min-height: calc(100vh - 280px);
  img {
    margin-bottom: 10px;
  }
  .video {
    width: 1080px;
  }
}
</style>
